import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P69-E1",
    audio: "img/FriendsPlus/Page68/Audio/audio-e3-p68.mp3",
    video: "Videos/e3.p68.mp4",
    component: UI,
    recorder: true,
    question: [],
    titleQuestion: [{ color: "#44509f", num: "1", title: 'Listen to the story and repeat. Act.' }],
    questionImage: [
      // Row
      [
        // Column3
        { url: "img/FriendsPlus/Page68/E3/4.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh1-e3-p68.mp3", },
        { url: "img/FriendsPlus/Page68/E3/5.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh2-e3-p68.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page68/E3/6.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh3-e3-p68.mp3", },
        { url: "img/FriendsPlus/Page68/E3/7.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh4-e3-p68.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page68/E3/8.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh5-e3-p68.mp3", },
        { url: "img/FriendsPlus/Page68/E3/9.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh6-e3-p68.mp3", },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P69-E2",
    audio: "img/FriendsPlus/Page69/Audio/audio-e2-p69.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page69/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page69/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page69/Audio/tieude-e2-p69.mp3",
        },
        { url: "img/FriendsPlus/Page69/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page69/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page69/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page69/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page69/Audio/hinh1-e2-p69.mp3",
        },
        {
          url: "img/FriendsPlus/Page69/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page69/Audio/hinh2-e2-p69.mp3",
        },
        {
          url: "img/FriendsPlus/Page69/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page69/Audio/hinh3-e2-p69.mp3",
        },
        {
          url: "img/FriendsPlus/Page69/E2/9.jpg",
          audioUrl: "img/FriendsPlus/Page69/Audio/hinh4-e2-p69.mp3",
        },
        { url: "img/FriendsPlus/Page69/E2/10.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page69/E2/11.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P69-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page69/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: 'Unit 10',
    id: 'SB3-U10-P69-E4',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page69/E4/Key/answerKey.png',
    titleQuestion: [{ num: '4', title: 'Look again and circle.', color: "#1F4199" }],
    question: {
      Write: {
        // checkUppercase: true,
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%' },
        limitSelect: 1,
        listWords: [
          'reading / singing', //0
          'band / wedding.', //1
          'eating / playing', //2
          'guests / bride.', //3
          'wearing / eating', //4
          'invitations / guests.', //5
          'sleeping / talking.', //6
        ],
        answers: ['0-0', '1-0', '2-4', '3-4', '4-0', '5-4', '6-4'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page69/E4/1.jpg" style="width: 100%">
        <div>
          <div><b>1</b>&nbsp;The girl has <span style='font-weight: bold;'>a cake / <span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">an invitation.</span></span></div>
          <div>&emsp;She’s <input id='0' type='Circle' /> it.</div>
        </div>
        <div>
          <div><b>2</b>&nbsp;Listen to the <input id='1' type='Circle' /></div>
          <div>&emsp;She’s <input id='2' type='Circle' /> music.</div>
        </div>
        <div>
          <div><b>3</b>&nbsp;Look at the <input id='3' type='Circle' /></div>
          <div>&emsp;She’s <input id='4' type='Circle' /> a white dress.</div>
        </div>
        <div>
          <div><b>4</b>&nbsp;Look at the <input id='5' type='Circle' /></div>
          <div>&emsp;They’re <input id='6' type='Circle' /></div>
        </div>
      `,
    },
  },
  5: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P69-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page69/E5/1.jpg" }]],
  },
};

export default json;
